export default "__VITE_ASSET__Bn$IOOrZ__"